// The window-name protocol between the toolbar (stamps it via window.open)
// and the breakout window (gates on it). Specs pin the literal independently.
export const CRITERIA_WINDOW_NAME_PREFIX = 'covidenceCriteriaWindow';

export const criteriaWindowName = (reviewId: string) =>
  `${CRITERIA_WINDOW_NAME_PREFIX}-${reviewId}`;

// Name-gated (not opener-gated) so an opener that closed before this runs
// still reads as a popup, whilst direct URL visits never do.
export const isCriteriaWindowPopup = () =>
  window.name.startsWith(CRITERIA_WINDOW_NAME_PREFIX);
